import { Stack } from "@mui/material";
import HelpAndShare from "components/LayoutFront/HelpAndShare";
import Decrees from "components/templates/who/Decrees";
import Governance from "components/templates/who/Governance";
import History from "components/templates/who/History";
import Tabs from "components/templatesComponents/Tabs";
import { tabsStyled, tabStyled } from "components/templatesComponents/TabsStyled";
import TemplateBanner from "components/templatesComponents/TemplateBanner";
import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";

export const tabsIdentifier = "t";

const Who = (props) => {
  const { page } = props;
  const { title, shortDescription, contents, template, fullPath } = page;
  const { history, decrees, decreesTitle, governance } = contents;

  const [sendTag, setSendTag] = useState(false);

  const { tab: historyTab, ...historyProps } = history;
  const { tab: decreesTab, ...decreesProps } = decrees;
  const { tab: governanceTab, ...governanceProps } = governance;

  const tabs = [
    {
      ...historyTab,
      identifier: tabsIdentifier,
      children: <History {...historyProps} />,
    },
    {
      ...decreesTab,
      identifier: tabsIdentifier,
      children: <Decrees {...decreesProps} decreesTitle={decreesTitle} />,
    },
    {
      ...governanceTab,
      identifier: tabsIdentifier,
      children: <Governance {...governanceProps} />,
    },
  ];

  const bo = useMemo(() => fullPath.startsWith("/?site="), [fullPath]);

  return (
    <>
      <TemplateBanner bo={bo}>
        <Stack>
          <h1>{title}</h1>
          {shortDescription && <p className="fr-text--xl">{shortDescription}</p>}
        </Stack>
      </TemplateBanner>
      <Tabs
        tabs={tabs}
        navigate={!bo}
        indicatorColor="none"
        sendTag={sendTag}
        setSendTag={setSendTag}
        tabsProps={{ sx: { ...tabsStyled, mt: 3 } }}
        tabProps={{ sx: tabStyled }}
        panelClass={{ mt: 4 }}
      />
      <HelpAndShare alwaysDisplayShare template={template} />
    </>
  );
};

Who.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.node,
    shortDescription: PropTypes.node,
    contents: PropTypes.shape(),
    template: PropTypes.string,
    fullPath: PropTypes.string,
  }).isRequired,
};

export default Who;
